import {
    ISRESULT,
    GET_DATA_MAIN_PLANTEMPLATE, GET_DATA_MAIN_PLANTEMPLATE_SUCCEEDED, REQUERT_MAIN_PLANTEMPLATE_FAILED, SET_DATA_MAIN_PLANTEMPLATE,
    GET_DATA_NEW_PLANTEMPLATE, GET_DATA_NEW_PLANTEMPLATE_SUCCEEDED, REQUERT_NEW_PLANTEMPLATE_FAILED, SET_DATA_NEW_PLANTEMPLATE,
    GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE, GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE_SUCCEEDED, REQUERT_PLANCONFIGBYSTEP_PLANTEMPLATE_FAILED, SET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE,
    GET_DATA_KHName_PLANTEMPLATE , GET_DATA_KHName_PLANTEMPLATE_SUCCEEDED,REQUERT_KHName_PLANTEMPLATE_FAILED,SET_DATA_KHName_PLANTEMPLATE,
    GET_DATA_Delete_PLANTEMPLATE,GET_DATA_Delete_PLANTEMPLATE_SUCCEEDED,REQUERT_Delete_PLANTEMPLATE_FAILED, GET_DATA_EMAIL, GET_DATA_EMAIL_SUCCEEDED, REQUERT_DATA_EMAIL_FAILED
    //IndexImportHygen
} from './actionTypes';

export const IsResultAction = (isResult) => {
    return {
        type: ISRESULT,
        isResult: isResult
    }
}

//MainPlanTemplate
export const GetDataMainPlanTemplateAction = (DataMain) => {
    return {
        type: GET_DATA_MAIN_PLANTEMPLATE,
        DataMain: DataMain
    }
}
export const GetDataMainPlanTemplateSuccessAction = (DataMain) => {
    return {
        type: GET_DATA_MAIN_PLANTEMPLATE_SUCCEEDED,
        DataMain: DataMain
    }
}
export const RequertMainPlanTemplateFaileAction = (Err) => {
    return {
        type: REQUERT_MAIN_PLANTEMPLATE_FAILED,
        err: Err
    }
}
export const SetDataMainPlanTemplateAction = (DataMain) => {
    return {
        type: SET_DATA_MAIN_PLANTEMPLATE,
        DataMain: DataMain
    }
}

//delete
// export const GetDeleteTemplateSuccessAction = (DataDelete) => {
//     return {
//         type: GET_DATA_Delete_PLANTEMPLATE_SUCCEEDED,
//         DataDelete: DataDelete
//     }
// }

export const DeleteTemplatePlanType = (DataDelete) => {
    return {
        type: GET_DATA_Delete_PLANTEMPLATE,
        DataDelete: DataDelete
    }
}

export const GetDataDeletePlanTemplateSuccessAction = (DataDelete) => {
    return {
        type: GET_DATA_Delete_PLANTEMPLATE_SUCCEEDED,
        DataDelete: DataDelete
    }
}
export const RequertDeleteTemplateFaileAction = (Err) => {
    return {
        type: REQUERT_Delete_PLANTEMPLATE_FAILED,
        err: Err
    }
}
//KHName
export const GetDataKHNamePlanTemplateAction = (DataKHName) => {
    return {
        type: GET_DATA_KHName_PLANTEMPLATE,
        DataKHName: DataKHName
    }
}
export const GetDataKHNamePlanTemplateSuccessAction = (DataKHName) => {
    return {
        type: GET_DATA_KHName_PLANTEMPLATE_SUCCEEDED,
        DataKHName: DataKHName
    }
}
export const RequertKHNamePlanTemplateFaileAction = (Err) => {
    return {
        type: REQUERT_KHName_PLANTEMPLATE_FAILED,
        err: Err
    }
}
export const SetDataKHNamePlanTemplateAction = (DataKHName) => {
    return {
        type: SET_DATA_KHName_PLANTEMPLATE,
        DataKHName: DataKHName
    }
}
//NewPlanTemplate
export const GetDataNewPlanTemplateAction = (id) => {
    return {
        type: GET_DATA_NEW_PLANTEMPLATE,
        id: id
    }
}
export const GetDataNewPlanTemplateSuccessAction = (DataNew) => {
    return {
        type: GET_DATA_NEW_PLANTEMPLATE_SUCCEEDED,
        DataNew: DataNew
    }
}
export const RequertNewPlanTemplateFaileAction = (Err) => {
    return {
        type: REQUERT_NEW_PLANTEMPLATE_FAILED,
        err: Err
    }
}
export const SetDataNewPlanTemplateAction = (DataNew) => {
    return {
        type: SET_DATA_NEW_PLANTEMPLATE,
        DataNew: DataNew
    }
}
//PlanConfigByStepPlanTemplate
export const GetDataPlanConfigByStepPlanTemplateAction = (id, stepNumberPerform) => {
    return {
        type: GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE,
        id: id,
        stepNumberPerform: stepNumberPerform
    }
}
export const GetDataPlanConfigByStepPlanTemplateSuccessAction = (DataPlanConfigByStep) => {
    return {
        type: GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE_SUCCEEDED,
        DataPlanConfigByStep: DataPlanConfigByStep
    }
}
export const RequertPlanConfigByStepPlanTemplateFaileAction = (Err) => {
    return {
        type: REQUERT_PLANCONFIGBYSTEP_PLANTEMPLATE_FAILED,
        err: Err
    }
}
export const SetDataPlanConfigByStepPlanTemplateAction = (DataPlanConfigByStep) => {
    return {
        type: SET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE,
        DataPlanConfigByStep: DataPlanConfigByStep
    }
}
//Get data email
export const GetDataEmailAction = () =>{
    return {
        type: GET_DATA_EMAIL
    }
}
export const GetDataEmailSuccessAction = (DataEmail) =>{
    return{
        type: GET_DATA_EMAIL_SUCCEEDED,
        DataEmail: DataEmail
    }
}
export const RequertDataEmailAction = (Err)=>{
    return{
        type: REQUERT_DATA_EMAIL_FAILED,
        err:Err
    }
}
//IndexUsingHygen